module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/hall-list/plan-photowedding-lineup-kanto-4-e38e743008e0a24cfefae5a605d02ae5.png";